import styled from 'styled-components'

export const MastheadWrapperStyled = styled.section`
  background-color: #fff;
`

export const StudySidebarCardWrapperStyled = styled.section`
  button {
    text-align: left;
    width: 220px;
  }
  padding-top: 1rem;
`
